















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { DxLookup, DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { MailConfig } from '@/installationConfig';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import {
  IMailTemplateDto,
  IMailContractCommand,
  ContractsClient,
  IContractDto,
  ContactsClient,
  MailContractCommand,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  MailTemplatesClient,
  MailTemplateType,
} from '@/data/web-api-client';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxLookup,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class ContractMailPopup extends Vue {
  @Prop({ required: true })
  contract!: IContractDto;

  @Prop()
  projectName!: string;

  @Prop()
  projectNumber!: string;
  templates: IMailTemplateDto[] = [];
  showValue: boolean = false;
  sending: boolean = false;
  formdata: IMailContractCommand | any = {
    to: [],
    from: '',
    template: '',
    cc: [],
    subject: '',
    content: '',
    documentNumber: '',
  };

  public async show() {
    this.formdata.documentNumber = this.contract.documentNumber;

    const lastUsedEmail = localStorage.getItem('contract_last_used_email');
    const lastUsedTemplate = localStorage.getItem('contract_last_used_template');
    if (lastUsedEmail) {
      this.formdata.from = lastUsedEmail;
    } else {
      this.formdata.from = this.currentUser.username;
    }

    if (lastUsedTemplate) {
      this.formdata.template = lastUsedTemplate;
      const template = this.templates.find((o) => o.name === lastUsedTemplate);
      if (template) {
        this.formdata.subject = template.subject ? template.subject : '';
        this.formdata.content = template.content ? template.content : '';
        this.replaceTags();
      }
    }

    try {
      if (this.contract && this.contract.subcontractorId) {
        const contact = await new ContactsClient(undefined, this.$axios).getBasicInfo(this.contract.subcontractorId);
        if (contact && contact.email) {
          this.formdata.to!.push(contact.email);
        }
      }
    } catch (err) {
      // do nothing
    }

    this.showValue = true;
  }

  async created() {
    try {
      this.templates = await new MailTemplatesClient(undefined, this.$axios).getAll(MailTemplateType.Contract);
    } catch {
      // do nothing
    }
  }

  replaceTags() {
    try {
      while (this.formdata.content.indexOf('#Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Name', this.contract.subcontractorName);
      }

      while ((this.formdata.content as string).indexOf('#DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#DocumentNumber', this.contract.documentNumber);
      }

      while ((this.formdata.subject as string).indexOf('#DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#DocumentNumber', this.contract.documentNumber);
      }

      while (this.formdata.content.indexOf('#Project_Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_Name', this.projectName);
      }
      while (this.formdata.subject.indexOf('#Project_Name') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_Name', this.projectName);
      }

      while (this.formdata.subject.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_DocumentNumber', this.projectNumber);
      }

      while (this.formdata.content.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_DocumentNumber', this.projectNumber);
      }
    } catch {
      // do nothing
    }
  }

  async send() {
    try {
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.sending = true;

      if (this.formdata.from) {
        localStorage.setItem('contract_last_used_email', this.formdata.from);
        localStorage.setItem('contract_last_used_template', this.formdata.template);
      }

      // TO KEEP MAIL FORMAT CORRECT, REPLACE P-TAG WITH DIV-TAG
      this.formdata.content = this.formdata.content.replaceAll('<p>', '<div>').replaceAll('</p>', '</div>');
      this.formdata.documentNumber = this.contract.documentNumber;

      await new ContractsClient(undefined, this.$axios).mail(new MailContractCommand(this.formdata));

      notificationService.showSuccessMessage('Mail verstuurd');
      this.showValue = false;
    } catch (err) {
      notificationService.showErrorMessage('Er ging iets mis bij het versturen van de mail.');
    } finally {
      this.sending = false;
    }
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }
          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
          }

          const res = await client.lookupContacts(
            new ContactsLookupQuery({
              projectId: this.contract.projectId,
              options: new DataSourceLoadOptionsBase(
                Object.assign({}, loadOptions, {
                  stringToLower: true,
                })
              ),
            })
          );

          return res;
        },
        byKey: async (val: string) => {
          return await client.getBasicInfo(val);
        },
      }),
      paginate: this.contract.projectId ? false : true,
    });
  }

  get contactOptions() {
    return {
      dataSource: this.contactDataSource,
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ['email', 'displayName'],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return 'undefined';
        }

        if (typeof item === 'string') {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return '';
        }

        if (typeof val === 'string') {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  get fromOptions() {
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        MailConfig.executionMailAddress,
        MailConfig.invoicingMailAddress,
        MailConfig.calculationMailAddress,
        this.currentUser.username,
      ],
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      onItemClick: (e: any) => {
        self.formdata.subject = e.itemData.subject;
        self.formdata.content = e.itemData.content;
        self.formdata.language = e.itemData.language;

        self.replaceTags();
      },
    };
  }
}
